// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"a9f25399","453":"30795db2"}[chunkId] + ".chunk.js";
};